import React from 'react';
import PropTypes from 'prop-types';

/**
 * TouchTarget component for expanding the hit area of its children.
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The content to be wrapped.
 * @returns {JSX.Element} A span element that expands the hit area.
 */
export function TouchTarget({ children }) {
  return (
    <>
      <span
        className="absolute left-1/2 top-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden"
        aria-hidden="true"
      />
      {children}
    </>
  );
}

TouchTarget.propTypes = {
  children: PropTypes.node.isRequired,
};
